import type {
  IQuickLinkClickEvent,
  IQuickLinkClickInput,
} from '../types/clickEvents';

const quickLinkClick = ({
  displayOrder,
  queryKey,
  highlight,
}: IQuickLinkClickInput): Omit<IQuickLinkClickEvent, 'event'> => ({
  position: `quick-links:${displayOrder}:${queryKey}${highlight ? `:${highlight}` : ''}`,
});

export default quickLinkClick;
